import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories, articles } from '@/mocks/siteData';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'yanqing');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const categoryArticles = articles.filter((a) => a.category === activeSlug);
  const categoryName = currentCategory?.name || '分类';

  return (
    <>
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '分类浏览', to: '/category/yanqing' },
                { label: categoryName },
              ]}
            />
            <h1 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {categoryName}
            </h1>
            <p className="mt-2 text-sm text-foreground-500 font-body">
              共 {categoryArticles.length} 部作品 · {currentCategory?.count.toLocaleString()} 部收录
            </p>
          </div>
        </div>

        <div className="bg-background-50 border-b border-background-200/70 overflow-x-auto">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex gap-2 py-3 whitespace-nowrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm font-label rounded-full transition-colors cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`${article.title} - po18阅读平台${categoryName}分类`}
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-label rounded-full">
                        {categoryName}
                      </span>
                      <span className="text-xs text-foreground-400 font-body">{article.date}</span>
                    </div>
                    <h2 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </h2>
                    <p className="mt-2 text-xs text-foreground-500 font-body line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-eye-line"></i>
                      <span>{article.views.toLocaleString()} 阅读</span>
                      <span className="mx-2">·</span>
                      <i className="ri-user-line"></i>
                      <span>{article.author}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 font-body">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}